import React from 'react'
import PropTypes from 'prop-types'
import { withFormsy } from 'formsy-react';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import Component from '../Component'
import Modal from "../Modal";
import DragAndDrop from "./DragAndDrop";

class ImageUpload extends Component {
    cropperRef = React.createRef();

    static DefaultWidth = 250;

    static defaultPropTypes = {
        ratio: 1
    }
    static propTypes = {
        label: PropTypes.string,

        source: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        width: PropTypes.number,
        height: PropTypes.number,
        ratio: PropTypes.number,
        circular: PropTypes.bool,
        onError: PropTypes.func,
    };


    static defaultProps = {
        label: 'Image',
    };


    constructor(props) {
        super(props);
        let previewUrl = { ...props }.source;
        if (previewUrl && TB.isObject(previewUrl)) {
            previewUrl = window.URL.createObjectURL(previewUrl);
        }

        this.state = {
            ...this.state,
            file: '',
            previewUrl,
            uploadSrc: null,
            originalSrc: { ...props }.source,
            previewImgStyle: {},
            crop: {
                unit: '%', // default, can be '%' or 'px'
                height: 50,
                x: 25,
                y: 25,
                aspect: props.ratio
            },
            freeCrop: props.freeCrop,
            minWidth: props.minWidth,

            maxWidth: props.maxWidth
        };
    }


    async componentDidMount()
    {
        if (this.state.croppedImageUrl || this.state.source) {
            let previewImgStyle = await this.getImageDimensions(this.state.croppedImageUrl ||
                (TB.isObject(this.state.source) ? this.state.previewUrl : this.state.source)
            )

            this.setState({ previewImgStyle })
        }
        await super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount()
    }

    confirmCrop = () => {

        // console.log('confirmCrop', this.state.croppedFile)
        this.props.setValue(this.state.croppedFile);
        this.setState({ isCropping: false }, async () => {

            await TB.wait(400)
            await this.modalRef.hideModal(true)
        })
    };

    loadImageFromSrc(src) {
        return new Promise(async (resolve, reject) => {
            let img = new Image();
            img.src = src;
            img.onload = () => {
                if (img) resolve(img)
            };
            img.onerror = () => {
                resolve(false)
            };
        });
    }

    async getImageDimensions(src) {
        let img = await this.loadImageFromSrc(src);
        if (!img) {
            return {}
        }
        let maxWidth = 600, maxHeight = 600 / this.props.ratio;
        let targetWidth = img.offsetWidth,
            targetHeight = img.offsetHeight;
        if (targetWidth > maxWidth || targetHeight > maxHeight) {
            if (targetWidth / targetHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
            }
        }
        if (this.props.ratio === 1) {
            if (targetWidth < targetHeight) {
                targetHeight = targetWidth;
            }else {
                targetWidth = targetHeight;
            }
        }

        return {
            height: targetHeight,
            width: targetWidth
        }
    }

    cancelCrop = async () => {

        window.URL.revokeObjectURL(this.state.croppedImageUrl);

        this.setState({
            isCropping: false,
            croppedImageUrl: null,
            uploadSrc: null,
            croppedFile: null
        }, async () => {
            if (this.state.originalSrc) {
                let previewImgStyle = await this.getImageDimensions(this.state.originalSrc);
                await this.promisedState({ previewImgStyle })
                this.props.setValue(this.state.originalSrc);
            } else {
                this.props.setValue(null)
            }
        });
    };

    onSelectFile = files => {
        if (files && files.length > 0) {
            const reader = new FileReader(), file = files[0];
            reader.addEventListener('load', () => {

                this.setState({
                    uploadSrc: reader.result,
                    isCropping: true
                }, () => this.modalRef.showModal());
            });
            reader.readAsDataURL(file);
        }
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = image => {
        this.imageRef = image;

        let percent = 100;
        const aspect = this.props.ratio;

        const width = (image.width > image.height ? percent : ((image.height * aspect) / image.width) * percent) / 2;
        const height = (image.height > image.width ? percent : ((image.width * aspect) / image.height) * percent) / 2;

        const y = ((percent - height) / 2);// / 1.5;
        const x = ((percent - width) / 2);// / 1.5;


        let crop = {
            unit: '%',
            width: image.width,
            // height,
            // x:x,
            // y: y,
            aspect
        };

        this.setState({
            crop
        }, () => {
            this.onCropComplete(this.cropperRef.current.makeNewCrop("px"))
        });

        return false; // Return false if you set crop state in here.
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop: percentCrop });
    };

    imageFrame() {
        let { width, height, ratio } = this.props;

        let frame = {
            width,
            height
        };

        if (!frame.width && !frame.height) {
            frame.width = this.constructor.DefaultWidth;
        }


        if (!ratio) {
            return frame;
        }

        if (frame.height) {
            frame.width = frame.height * ratio;
            return frame;
        }

        frame.height = frame.width / ratio;
        return frame;
    }

    render() {
        let previewStyle = {
            ...this.imageFrame(),
            ...this.state.previewImgStyle,
            backgroundRepeat: 'no-repeat'
        };

        let { crop, croppedImageUrl, isCropping, previewUrl } = this.state;
        let {
            circular,
            getErrorMessage,
            isFormSubmitted,
            showRequired,
            showError,
            source,
            ratio = crop.aspect,
            disabled
        } = this.props;


        crop.aspect = ratio;

        if (circular) {
            previewStyle.borderRadius = '50%';
        }


        if (croppedImageUrl || source) {
            // previewStyle.backgroundColor = '#EAEAEA';
            previewStyle.backgroundImage = `url("${croppedImageUrl || (TB.isObject(source) ? previewUrl : source)}")`;
            if (TB.isMobile() && this.props.shouldResize) {
                previewStyle.width = '100%';
            }
        }

        let errorClass = isFormSubmitted() &&
            (showRequired() || showError()) ?
            'is-invalid' :
            null;

        return (
            <div
                className={`image-upload-container form-group ${errorClass ? 'text-danger' : ''} ${disabled && 'disabled'}`}>
                <label className="col-form-label" data-required="true">
                    {this.props.label}
                    {this.props.required && <span className="required-symbol"> *</span>}
                </label>
                {this.props.labelHint && (
                    <p className="label-hint">
                        {this.props.labelHint}
                    </p>
                )}
                {(croppedImageUrl || source) ? [
                    this.props.dropContainer ? (
                        <div key="image-upload-preview-sourced"  className={"image-upload-preview preview-drop-container " + (circular && 'img-grayscale')}>

                            <div key="iupc"
                                 className={`btn-file form-component ${errorClass}`}>
                                {this.props.dropContainer}

                                <div className="image-edit-btn">
                                    <i className="fa fa-edit" />
                                </div>
                                {!disabled && !isCropping && (
                                    <input
                                        name={this.props.name}
                                        type="file"
                                        title=" "
                                        accept="image/*"
                                        onChange={e => this.onSelectFile(e.target.files)} />
                                )}
                            </div>
                        </div>
                    ) :(
                        <div key="image-upload-preview-sourced" style={previewStyle}
                             className={"image-upload-preview " + (circular && 'img-grayscale')}>

                            {!disabled && (
                                <div key="iupc"
                                     className={`btn-file form-component ${errorClass}`}>

                                    <div className="image-edit-btn">
                                        <i className="fa fa-edit" />
                                    </div>
                                    {!isCropping && (
                                        <input
                                            name={this.props.name}
                                            type="file"
                                            title=" "
                                            accept="image/*"
                                            onChange={e => this.onSelectFile(e.target.files)} />
                                    )}
                                </div>
                            )}

                        </div>
                    ),

                ] : (
                        <DragAndDrop
                            dropContainer={this.props.dropContainer}
                            handleDrop={this.onSelectFile} disabled={this.props.disabled}
                            name={this.props.name} />
                    )}


                {this.renderCropper()}

                <div className="invalid-feedback">
                    <div>{getErrorMessage()}</div>
                </div>

            </div>
        )
    }

    renderCropper() {
        let { crop, croppedImageUrl, uploadSrc } = this.state;
        let {
            circular,
            ratio = crop.aspect,
            freeCrop,
            minWidth,
            minHeight
        } = this.props;

        crop.aspect = freeCrop ? undefined : ratio;
        let previewStyle = this.imageFrame();
        if (circular) {
            previewStyle.borderRadius = '50%';
            previewStyle.overflow = 'hidden';
        }

        return (
            <Modal ref={modalRef => this.modalRef = modalRef}
                modalClass="position-fixed modal-fixed"
                title="Edit Image" onCloseAction={() => this.cancelCrop()}>
                <div className={'image-crop-container flex-col'} style={{ minWidth: 450 }}>
                    <div className="mb-2 mx-2 items-center justify-center flex-col flex">
                {uploadSrc && (
                            <ReactCrop
                                ref={this.cropperRef}
                                src={uploadSrc}
                                crop={crop}
                                circularCrop={circular}
                                minWidth={minWidth}
                                minHeight={minHeight}
                                imageStyle={{
                                    backgroundColor: '#EAEAEA',
                                    padding: 20,
                                    maxWidth: "30vw",
                                    maxHeight: '40vh',
                                    height: 'auto',
                                    width: 'auto'
                                }}
                                onImageLoaded={(image) => this.onImageLoaded(image)}
                                onComplete={this.onCropComplete}
                                onChange={this.onCropChange}
                            />
                        )}
                    </div>

                    <div className="flex-col mb-3 mt-3 mx-2 flex items-center justify-center">
                        <p className={"text-primary text-center mb-0"}>Preview</p>
                        <div className="bg-gray p-1">
                            <div style={previewStyle}
                                className={" image-upload-preview " + (circular && 'img-grayscale')}>
                                {croppedImageUrl && (
                                    <div style={{
                                        backgroundColor: '#EAEAEA',
                                        backgroundImage: `url(${croppedImageUrl})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        backgroundSize: 'contain',
                                        minWidth: this.constructor.DefaultWidth * 0.5,
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        height: 'inherit',
                                        width: 'inherit'
                                    }} />
                                )}
                            </div>
                        </div>

                    </div>
                    <div className="flex-row flex items-center justify-center">
                        <button type="button" onClick={this.confirmCrop.bind(this)}
                            className={`btn btn-primary`}>
                            <i className={'fa fa-check'} />
                        </button>
                        <button type="button" onClick={async () => {
                            if (this.props.source) {
                                let previewImgStyle = await this.getImageDimensions(this.props.source);
                                await this.promisedState({ previewImgStyle })
                                this.props.setValue(this.props.source);
                            } else {
                                this.props.setValue()
                                    }

                            await this.modalRef.hideModal()
                        }}
                            className={`btn btn-outline-primary ml-2`}>
                            <i className={'fa fa-times'} />
                        </button>
                    </div>

                </div>
            </Modal>
        )

    }

    async makeClientCrop(crop) {
        if (this.imageRef) {
            const { fileUrl, blob } = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.png'
            );
            this.setState({
                croppedImageUrl: fileUrl,
                croppedFile: blob
            });
        }
    }

    getCroppedImg(image, crop, fileName) {

        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        let originWidth = crop.width * scaleX;
        let originHeight = crop.height * scaleY;
        // maximum width/height
        let maxWidth = 2048, maxHeight = 2048 / this.props.ratio;
        let targetWidth = originWidth,
            targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        // set canvas size
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            ((crop.x - 20) * scaleX),
            ((crop.y - 20) * scaleY),
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            targetWidth,
            targetHeight
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                blob.name = fileName;

                window.URL.revokeObjectURL(this.state.fileUrl);

                let fileUrl = window.URL.createObjectURL(blob);

                resolve({
                    fileUrl,
                    blob
                });
            }, 'image/png');
        });
    }

}

export default withFormsy(ImageUpload);